//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
  searchInput: {
    width: 400,
    borderRadius: 20,
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  searchInputIcon: {
    cursor: "pointer",
  },
  root: {
    flexGrow: 1,
    marginBottom: 20,
  },
  tableDownInResponsive: {
    marginBottom: 150,
  },
  createBtn: {
    float: "right",
  },
  link: {
    color: "blue",
    textDecoration: "underline",
    cursor: "pointer",
  },
  // Create
  dateInput: {
    width: "100%",
  },
  submitBtn: {
    color: "#fff",
    backgroundColor: "#305698 !important",
    fontSize: 15,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    width: 100,
    "&:hover": {
      backgroundColor: "#305698 !important",
    },
  },
  // View
  label: {
    verticalAlign: "-webkit-baseline-middle",
  },
  editInput: {
    width: "80%",
  },
  cancelBtn: {
    color: "#305698",
    backgroundColor: "#fff !important",
    fontSize: 15,
    border: "1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    width: 100,
    "&:hover": {
      backgroundColor: "#fff !important",
    },
  },
  // Dialog
  dialogParentDiv: {
    padding: 25,
  },
  parentText: {
    fontSize: 25,
  },
}));
